import prepareUpdateSettings from './prepareUpdateSettings';
import setApiSourceFormModalOpenStatus from './setApiSourceFormModalOpenStatus';

export default (sunwiseProjectId, powerStationsDataId) => (dispatch) => {
    if (powerStationsDataId) dispatch(setApiSourceFormModalOpenStatus(true));
    else dispatch(prepareUpdateSettings(sunwiseProjectId));
};
